import { useEffect } from 'react';

/**
 * Fades/slides elements marked with `data-reveal` into view as they enter the
 * viewport. Base and revealed states live in index.css so nothing flashes
 * before this runs. Elements are unobserved once shown — reveal happens once.
 */
export default function useScrollReveal() {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll('[data-reveal]'));
    if (nodes.length === 0) return undefined;

    // No IntersectionObserver (or motion is unwanted): show everything.
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      nodes.forEach(node => node.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    nodes.forEach(node => observer.observe(node));
    return () => observer.disconnect();
  }, []);
}
